import classNames from 'classnames';
import type React from 'react';
import { memo, useCallback } from 'react';
import styles from 'src/widgets/policy/components/links.module.scss';
import { useAnalytics } from '@features/Analytics';
import { FormattedMessage, type TpMessageKeys } from '@features/intl';
const PLACES = ['paywall', 'checkout', 'burger_menu', 'email_modal', 'upsale', 'explit_checkout'] as const;
type Place = (typeof PLACES)[number];
const DEFAULT_ID: TpMessageKeys = 'Onboarding.Menu.Tos';
const MESSAGE_MAP: Record<Place, TpMessageKeys> = {
  burger_menu: 'Onboarding.Menu.Tos',
  paywall: 'Onboarding.Paywall.Main.Contact.Terms.A',
  upsale: 'Onboarding.Book.Terms.A',
  checkout: 'Onboarding.Checkout.Terms.A',
  email_modal: 'Onboarding.Menu.Tos',
  explit_checkout: 'Onboarding.Menu.Tos'
};
export const TermsLink = memo(({
  place,
  className,
  children
}: {
  className?: string;
  place: Place;
  children?: React.ReactNode;
}) => {
  const {
    trackGoogleEvent
  } = useAnalytics();
  const formattedMessageId = MESSAGE_MAP[place] ?? DEFAULT_ID;
  const handleClick = useCallback(() => {
    trackGoogleEvent({
      eventName: 'link_open',
      options: {
        place,
        link_name: 'terms'
      }
    });
  }, [place, trackGoogleEvent]);
  return <a className={classNames(styles.link, className)} href="https://legal.mentalgrowth.app/mimika/tos.pdf" target="_blank" rel="noreferrer" onClick={handleClick}>
        {children || <FormattedMessage id={formattedMessageId} />}
      </a>;
});
TermsLink.displayName = 'TermsLink';